﻿import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import React, { useState } from 'react';
import formStyles from '../../../../components/form/form.module.scss';
import clsx from 'clsx';
import { formatDate } from '../../../../helpers/abas-helper.ts';
import { getStatusImage } from './Accordion.tsx';
import pageStyles from '../WarrantyRequestHistoryPage.module.scss';
import Chevron from 'assets/icons/chevron.svg?react';
import { WarrantyRequestDevice } from '../../../../services/api/api-client.types.ts';
import { tDynamic } from '../../../../helpers/tDynamic.ts';

type OwnProps = {
  data: WarrantyRequestDevice[];
};

const columnsOfOuterTable: {
  translateKey: string;
  serverKey: string;
}[] = [
  {
    serverKey: 'serialNumber',
    translateKey: 'table_SN',
  },
  {
    serverKey: 'name',
    translateKey: 'table_device_name',
  },
  {
    serverKey: 'article',
    translateKey: 'article',
  },
  {
    serverKey: 'deliveryDate',
    translateKey: 'table_delivery_date',
  },
  {
    serverKey: '',
    translateKey: 'parts_count',
  },
  {
    serverKey: '',
    translateKey: 'status',
  },
];

const outerTableTextStyles = [pageStyles.text, pageStyles.overflowEllipsis];

export const InnerAccordion = (props: OwnProps) => {
  const i18n = useScopedTranslation('Page.WarrantyHistoryPage');

  const { data } = props;

  const [openedDevices, setOpenedDevices] = useState<Set<string>>(
    new Set(data.map((item) => item.serialNumber)),
  );

  const handleClickDevice = (key: string) => {
    const copy = new Set(openedDevices);

    if (copy.has(key)) {
      copy.delete(key);
    } else {
      copy.add(key);
    }

    setOpenedDevices(copy);
  };

  return (
    <div>
      <div className={pageStyles.headerContainer}>
        {columnsOfOuterTable.map((column, index) => {
          return (
            <div
              key={column.translateKey as string}
              className={clsx(
                pageStyles.headerTitle,
                pageStyles.paddingLeftRight16,
                index === 1
                  ? pageStyles.flex2
                  : index === columnsOfOuterTable.length - 1
                  ? pageStyles.width70
                  : index === columnsOfOuterTable.length - 2
                  ? pageStyles.width117
                  : pageStyles.flex1,
                column.serverKey && pageStyles.pointer,
                pageStyles.headerTitleActive,
                pageStyles.rowContainerSorting,
              )}
            >
              <div>{tDynamic(i18n, column.translateKey)}</div>
            </div>
          );
        })}
      </div>
      {data.map((item, index) => (
        <div data-test-id={'group-container'} key={item.serialNumber}>
          <div
            className={clsx(
              pageStyles.rowContainer,
              pageStyles.container,
              !openedDevices.has(item.serialNumber) &&
                index === data.length - 1 &&
                pageStyles.borderBottom,
            )}
          >
            <Chevron
              className={clsx(
                pageStyles.pointer,
                !openedDevices.has(item.serialNumber) &&
                  pageStyles.transform180,
              )}
              onClick={() => handleClickDevice(item.serialNumber)}
            />
            <div
              data-test-id={'group-order-number'}
              className={clsx(
                outerTableTextStyles,
                pageStyles.flex1,
                formStyles.serialNumber,
              )}
            >
              {item.serialNumber}
            </div>
            <div
              data-test-id={'group-date'}
              className={clsx(outerTableTextStyles, pageStyles.flex2)}
            >
              {item.name}
            </div>
            <div
              data-test-id={'group-reference'}
              className={clsx(outerTableTextStyles, pageStyles.flex1)}
            >
              {item.article}
            </div>
            <div className={clsx(outerTableTextStyles, pageStyles.flex1)}></div>
            <div className={clsx(outerTableTextStyles, pageStyles.width117)}>
              {item.parts.length}
            </div>
            <div className={clsx(outerTableTextStyles, pageStyles.width70)} />
          </div>
          {openedDevices.has(item.serialNumber) && (
            <div style={{ paddingLeft: 20 }}>
              {item.parts.map((part, index) => (
                <div
                  key={part.article}
                  className={clsx(
                    pageStyles.rowContainer,
                    index === data.length - 1 && pageStyles.borderBottom,
                  )}
                >
                  <div
                    className={clsx(outerTableTextStyles, pageStyles.flex1)}
                  />
                  <div className={clsx(outerTableTextStyles, pageStyles.flex2)}>
                    {part.name}
                  </div>
                  <div className={clsx(outerTableTextStyles, pageStyles.flex1)}>
                    {part.article}
                  </div>
                  <div className={clsx(outerTableTextStyles, pageStyles.flex1)}>
                    {formatDate(part.deliveryDate ?? '')}
                  </div>
                  <div
                    className={clsx(outerTableTextStyles, pageStyles.width117)}
                  />
                  <div
                    className={clsx(outerTableTextStyles, pageStyles.width70)}
                  >
                    {getStatusImage([part.garantie], true)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
